<script lang="ts">
	import type { PoiCardSize } from './types';
	import SkeletonBlock from '$lib/components/atoms/skeleton/SkeletonBlock.svelte';
	import SkeletonText from '$lib/components/atoms/skeleton/SkeletonText.svelte';
	import PoiCardTemplate from './PoiCardTemplate.svelte';

	interface Props {
		index: number;
		tag: string;
		size?: PoiCardSize;
		withPicture?: boolean;
	}

	const {
		index,
		tag,
		size = 'lg',
		withPicture = true,
	}: Props = $props();
</script>

<PoiCardTemplate
	{tag}
	dataTestId={`poi-card-skeleton-${index}`}
	category="skeleton"
	class={['poi-card-skeleton shadow-smooth-block p-1 w-full h-68 b-0 bg-neutral-weakest', size]}>
	{#snippet content()}
		{#if withPicture}
			<SkeletonBlock
				width="100%"
				height="136px"
				borderRadius="0"
				class="relative rd-2 h-34 w-full bg-neutral-soft"
			/>
			<div class="w-full text-body text-md mb-2 mt-2">
				<SkeletonText
					minWords={2}
					maxWords={2}
					minWordLength={6}
					maxWordLength={14}
					class="max-w-full"
				/>
			</div>
			<div class="text-2">
				<SkeletonText minWords={1} maxWords={1} minWordLength={22} maxWordLength={22} />
				<SkeletonText minWords={2} maxWords={2} minWordLength={8} maxWordLength={18} />
			</div>
		{:else}
			<div class="w-full text-body text-md mb-2">
				<SkeletonText
					minWords={2}
					maxWords={2}
					minWordLength={6}
					maxWordLength={14}
					class="max-w-full"
				/>
			</div>
			<div class="text-2 mb-4 flex flex-col gap-2">
				<SkeletonText minWords={1} maxWords={1} minWordLength={22} maxWordLength={22} />
				<SkeletonText minWords={2} maxWords={2} minWordLength={6} maxWordLength={18} />
				<SkeletonText minWords={2} maxWords={2} minWordLength={6} maxWordLength={26} />
				<SkeletonText minWords={2} maxWords={2} minWordLength={4} maxWordLength={18} />
				<SkeletonText minWords={3} maxWords={3} minWordLength={1} maxWordLength={20} />
				<SkeletonText minWords={1} maxWords={1} minWordLength={22} maxWordLength={22} />
				<SkeletonText minWords={2} maxWords={2} minWordLength={8} maxWordLength={18} />
				<SkeletonText minWords={1} maxWords={1} minWordLength={22} maxWordLength={22} />
			</div>
		{/if}
	{/snippet}
	{#snippet footer()}
		<SkeletonBlock
			width="auto"
			height="44px"
			borderRadius="0.25rem"
			class="bg-neutral-soft w-full"
		/>
	{/snippet}
</PoiCardTemplate>
